import axios from 'axios';

export default {
  getAll() {
    return axios.get('/v1/portal-category/content');
  }
};
